<template>
  <section class="c-section c-section--postulate">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card>
            <div class="container-fluid p-0">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <div style="min-width: 300px; width: 60%; margin: 0 auto 100px"
            class="d-flex align-items-start align-items-lg-center
              justify-content-center flex-column flex-lg-row">
                <div
                  class="w-100 mb-4 d-flex justify-content-center align-items-center flex-column"
                >
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-2"></b-skeleton>
                    <b-skeleton animation="wave" width="90%" type="input" class="mb-2"></b-skeleton>
                    <b-skeleton animation="wave" type="button" class="mb-3"></b-skeleton>
                    <b-skeleton-img no-aspect width="80%" height="300px">
                  </b-skeleton-img>
                </div>
              </div>
            </div>
          </b-card>
      </template>
      <div v-if="context.banner" class="c-banner-top">
        <img :src="context.banner.fondo" alt="" class="c-banner-top__background">
        <div class="c-banner-top__gradient"></div>
        <div class="container position-relative h-100">
          <figure class="c-banner-top__semiluna">
            <img
              src="@/assets/images/semiluna.png"
              alt=""
              class="w-100 of--contain d-none d-md-block"
            >
          </figure>
          <div class="c-banner-top__contain">
            <div data-aos="fade-right">
              <h2 class="white fs-40 fs-md-50 w-black mb-0">
                {{context.post.post_title}}
              </h2>
              <div class="d-flex">
                <router-link to="/" class="c-banner-top__link">
                  Inicio
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <p class="white fs-16 w-medium mb-0">
                  {{context.post.post_title}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.formulario" class="c-postulate">
        <div class="container">
          <div class="row justify-content-center">
            <div data-aos="fade-up" class="col-12 col-md-8 col-lg-6">
              <h2 class="text-center sec-alt fs-16 w-sbold mb-3">
                {{context.formulario.subtitulo}}
              </h2>
              <h2 v-html="titulo" class="c-postulate__title mb-5">
              </h2>
            </div>
            <div data-aos="fade-up" class="col-10 col-md-10 col-lg-10">
              <div class="c-certificates__info sec-alt fs-16 text-center pb-4">
                <p class="mb-4" v-html="context.formulario.descripcion">
                </p>
              </div>
            </div>
            <div v-if="context.formulario.mostrar_formulario"
            data-aos="fade-up" class="col-12 col-md-8 col-lg-6">
              <div data-aos="fade-left" class="c-postulate__container">
                <form action="">
                  <div class="row gy-4">
                    <div class="col-12 col-lg-6">
                      <div
                        class="c-form-group"
                        :class="{ 'c-form-group--error': $v.user.name.$error }"
                      >
                        <input
                          class="c-form-group__input"
                          placeholder="Nombres"
                          v-model.trim="$v.user.name.$model"
                        />

                        <span class="c-form-group__error" v-if="!$v.user.name.required">
                          Nombres son requeridos
                        </span>
                        <span class="c-form-group__error" v-if="!$v.user.name.minLength">
                          Nombres debe tener al menos
                          {{$v.user.name.$params.minLength.min}} caracteres.
                        </span>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div
                        class="c-form-group"
                        :class="{ 'c-form-group--error': $v.user.email.$error }"
                      >
                        <input
                          class="c-form-group__input"
                          placeholder="Email"
                          v-model.trim="$v.user.email.$model
                        "/>

                        <div class="c-form-group__error" v-if="!$v.user.email.required">
                          Email es requerido
                        </div>
                        <div class="c-form-group__error" v-if="!$v.user.email.alpha">
                          No es un email
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div
                        class="c-form-group"
                        :class="{ 'c-form-group--error': $v.user.attachment.$error }"
                      >
                        <label
                          class="c-form-group__label w-100"
                          :class="{'black': user.attachment }"
                          for="doc"
                        >
                          <p class="mb-0 d-flex align-items-center" v-if="!user.attachment">
                            <span class="fs-21 d-flex me-1">
                              <Icon icon="carbon:document-add"/>
                            </span>
                            Adjuntar CV (.pdf) {{ user.attachment }}
                          </p>
                          <p class="mb-0">{{fileName}}</p>
                          <input
                            name="doc"
                            id="doc"
                            class="c-form-group__input d-none"
                            type="file"
                            @change="attachmentFileChanged($event)"
                          />
                        </label>

                        <div class="c-form-group__error" v-if="!$v.user.attachment.file.required">
                          Documento es requerido
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div
                        class="c-form-group"
                        :class="{ 'c-form-group--error': $v.user.message.$error }"
                      >
                        <textarea
                          class="c-form-group__input"
                          placeholder="Detalles de la consulta"
                          v-model.trim="$v.user.message.$model"
                          name=""
                          id=""
                          cols="30"
                          rows="8"
                        >
                        </textarea>

                        <span class="c-form-group__error" v-if="!$v.user.message.required">
                          Detalles son requeridos
                        </span>
                        <span class="c-form-group__error" v-if="!$v.user.message.minLength">
                          Detalles debe tener al menos
                          {{$v.user.message.$params.minLength.min}} caracteres.
                        </span>
                      </div>
                    </div>
                    <div class="col-12">
                      <button
                        type="button"
                        @click="submit()"
                        :disabled="loading"
                        class="c-button c-button--primary w-100">
                        {{ (loading) ? 'Enviando...' : 'Registrarme'}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
      id="modalSuccess"
        title="BootstrapVue" hide-footer hide-header hide-actions centered size="lg"
      >
        <div class="c-modal c-modal--success">
          <div class="text-end pt-4">
            <div class="text-end pe-3 pt-2">
              <span style="opacity:0" class="c-modal__cross fs-30">
                <Icon icon="gridicons:cross-circle" />
              </span>
            </div>
          </div>
          <div class="pt-0 mb-2">
            <div style="margin-top:-48px;" class="c-modal__icon-success text-center mb-2">
              <!-- <Icon icon="clarity:success-standard-line" /> -->
            </div>
            <h2 class="c-modal__title c-modal__title-success text-center w-bold pe-4 ps-4">
              ¡TU REGISTRO FUE INGRESADO CON ÉXITO!
            </h2>
            <div class="c-modal__text-success text-center p-4 pt-0">
              <p>Muy pronto nos comunicaremos contigo.</p>
                <div class="text-center mt-3">
                  <button
                    @click="$bvModal.hide('modalSuccess')"
                    class="c-button c-button--primary c-modal__btn-success d-inline"
                  >
                    Cerrar
                  </button>
                </div>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal id="modalError" hide-footer hide-header hide-actions centered>
        <div class="c-modal c-modal--error">
          <div class="text-end">
            <div class="text-end pe-3 pt-2">
              <span @click="$bvModal.hide('modalError')" class="c-modal__cross fs-30">
                <Icon icon="gridicons:cross-circle" />
              </span>
            </div>
          </div>
          <div class="p-4 pt-0 text-center">
            <h2 class="c-modal__title">Error al enviar</h2>
            <p class="mb-0" v-html="error.message"></p>
          </div>
        </div>
      </b-modal>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
import {
  requiredIf,
  required,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      user: {
        name: '',
        email: '',
        attachment: '',
        message: '',
      },
      fileName: '',

      loading: false,
      error: {
        title: '',
        message: '',
      },

      context: {},
      contextLoading: true,
      titulo: '',
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'responsabilidad-social' });
  },
  validations: {
    user: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        alpha: helpers.regex('alpha', /.+@.+\..+/),
      },
      attachment: {
        file: {
          required: requiredIf(function file() {
            return this.user.attachment.length === 0;
          }),
        },
      },
      message: {
        required,
        minLength: minLength(4),
      },
    },
  },
  computed: {
    attachmentName() {
      let extension = '';
      let name = '';

      if (this.user.attachment) {
        extension = this.user.attachment.name.split('.');
        extension = extension[extension.length - 1];

        if (this.user.attachment.name.length > 15) {
          name = this.user.attachment.name
            .substring(0, 15);

          name = `${name}....${extension}`;
        } else {
          name = this.user.attachment.name;
        }
      }

      return (!this.user.attachment)
        ? 'Subir boleta ó factura de compra'
        : name;
    },
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.context.post.content;
        this.titulo = tempDiv.getElementsByTagName('h2')[0].innerHTML;
      }
    },
  },
  methods: {
    attachmentFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;
      this.fileName = files[0].name;

      if (!files.length) {
        this.attachment = '';

        return;
      }

      [this.user.attachment] = files;
    },

    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loading = true;
        const formData = new FormData();

        console.log(this.user.attachment, 'aaaa');

        formData.append('name', this.user.name);
        formData.append('email', this.user.email);
        formData.append('invoice_file', this.user.attachment);
        formData.append('message', this.user.message);
        console.log(this.user.attachment, 'dddsss');

        fetch(`${process.env.VUE_APP_API}/postular`, {
          method: 'POST',
          body: formData,
        })
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .then((response) => {
            if (response.status) {
              this.loading = false;
              this.user.name = '';
              this.user.email = '';
              this.user.attachment = '';
              this.user.message = '';
              this.$v.$reset();
              this.$bvModal.show('modalSuccess');
            } else {
              this.loading = false;

              this.error = {
                title: 'Error al enviar',
                message: '¡Ha ocurrido un error enviar! 😥⚠️🚨, intentelo más tarde (revisar datos)',
              };

              this.$bvModal.show('modalError');
            }
          })
          .catch((err) => {
            this.loading = false;
            this.error = {
              title: 'Error al enviar',
              message: '¡Ha ocurrido un error enviar! 😥⚠️🚨, intentelo más tarde (revisar datos)',
            };
            this.$bvModal.show('modalError');
            throw err;
          });
      }
    },
  },
};
</script>
